import { SET_LOGIN_DETAILS, SET_LOGOUT_DETAILS } from "./type";

const initialState = {
  clientDetails: {},
  userTokens: {
    accessToken: "",
  },
  isClientLoggedIn: false,
};

// Creating the client reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOGIN_DETAILS:
      return {
        ...state,
        clientDetails: action.payload.clientDetails,
        userTokens: action.payload.userTokens,
        isClientLoggedIn: action.payload.isClientLoggedIn,
      };
    // Usually includes clientDetails, userTokens, isClientLoggedIn: true
    case SET_LOGOUT_DETAILS:
      return { ...state, ...action.payload }; // Reset login state and tokens
    default:
      return state;
  }
}
